import React from 'react';
import { UserButton, useUser } from '@clerk/clerk-react';

interface UserProfileProps {
  className?: string;
}

const UserProfile: React.FC<UserProfileProps> = ({ className = '' }) => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  return (
    <div className={`user-profile ${className}`}>
      <div className="user-info">
        <UserButton 
          appearance={{
            elements: {
              avatarBox: "h-8 w-8",
              userButtonTrigger: "focus:shadow-none"
            }
          }}
        />
        <div className="user-details">
          <div className="user-name">
            {user.fullName || user.firstName || 'User'}
          </div>
          <div className="user-email">
            {user.primaryEmailAddress?.emailAddress}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile; 